import { render, staticRenderFns } from "./BookCategory.vue?vue&type=template&id=ab518596&scoped=true"
import script from "./BookCategory.vue?vue&type=script&lang=js"
export * from "./BookCategory.vue?vue&type=script&lang=js"
import style0 from "./BookCategory.vue?vue&type=style&index=0&id=ab518596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab518596",
  null
  
)

export default component.exports